import React, {useEffect, useState} from "react";
import {connect} from 'react-redux'
import {withRouter} from "react-router";
import {DemandValidation} from 'constants/DemandValidation';
import Loading from "components/Loading";
import ArchivingService from "services/ArchivingService";
import Tr from "translations/Translations";
import Typography from "components/Typography";
import GridBlock from "components/GridBlock";
import Button from "components/Button";
import ArchiveIcon from '@material-ui/icons/Archive';
import {makeStyles} from "@material-ui/core";
import {ArchivingStatus, statusScheduleAvailable} from "./constants/ArchivingStatus";
import SimpleTable from "components/complex/simpleTable/SimpleTable";
import DateFormats from "constants/DateFormats";
import moment from "libs/moment";
import downloadFile from "libs/downloadFile";
import {getUserFullNameWithDeputy} from "libs/userNameGetter";


const useStyle = makeStyles(theme => ({
    root: {
        width: '100%'
    },
    icon: theme.components.icon,
    text: {
        marginBottom: theme.spacing(2)
    }
}))

function ArchivingPanel(
    {
        match,
        demandValidation,
        demandArchiving
    }) {

    const classes = useStyle();
    const curDemandValidation = DemandValidation.ARCHIVING;
    const demandId = match.params.id;
    const section = demandValidation.find(x => x.section === curDemandValidation);
    const editable = section ? section.editable : false;
    const [working, setWorking] = useState(false)

    useEffect(() => {
        ArchivingService.getDemandArchiving(demandId);
        return () => {
            ArchivingService.clearDemandArchiving();
        }
    }, [demandId])

    const scheduleArchive = () => {
        ArchivingService.scheduleArchive(demandId);
    };

    const downloadArchive = () => {
        const archiveUrl = demandArchiving?.info?.archiveUrl;
        if (archiveUrl) {
            setWorking(true);
            downloadFile({url: archiveUrl.url, name: archiveUrl.name});
        }
    };

    const getDescription = () => {

        if (!demandArchiving.archivingStatus) {
            if (editable) {
                return Tr('demand_archiving_schedule_available')
            } else {
                return Tr('demand_archiving_schedule_unavailable')
            }
        } else {
            return Tr('demand_archiving_' + demandArchiving.archivingStatus.toLowerCase())
        }
    }

    const getButton = () => {

        if (!demandArchiving.archivingStatus || demandArchiving.archivingStatus === ArchivingStatus.ARCHIVE_EXPIRED) {
            return <Button
                onClick={scheduleArchive}
                disabled={!editable || !statusScheduleAvailable(demandArchiving.archivingStatus)}
            >
                {Tr('demand_archiving_button')}
            </Button>
        } else if (demandArchiving.archivingStatus === ArchivingStatus.ARCHIVED) {
            return <Button
                onClick={downloadArchive}
                disabled={!editable || working}
            >
                {Tr('demand_archiving_button_download')}
            </Button>
        }

    }

    if (!demandArchiving) return <Loading/>
    return (
        <GridBlock
            className={classes.root}
            direction='column'
            alignItems='center'

        >
            <ArchiveIcon className={classes.icon} color='primary'/>
            <Typography className={classes.text}>{getDescription()}</Typography>

            {!!demandArchiving.info &&
            <SimpleTable
                className={classes.text}
                headers={[
                    Tr('case_number'),
                    Tr('proceedings_subject'),
                    Tr('demand_archiving_order_date'),
                    Tr('demand_archiving_create_date'),
                    Tr('demand_archiving_user')
                ]
                }
                items={[[
                    demandArchiving.info.demandNumber,
                    demandArchiving.info.demandName,
                    moment(demandArchiving.info.orderDate).format(DateFormats.DATETIME_FORMAT),
                    demandArchiving.info.createDate ? moment(demandArchiving.info.createDate).format(DateFormats.DATETIME_FORMAT) : null,
                    getUserFullNameWithDeputy(demandArchiving.info.user)
                ]]}
            />
            }
            {getButton()}

        </GridBlock>
    )
}


export default connect((state) => ({
    demandValidation: state.resources.demandValidation,
    demandArchiving: state.resources[ArchivingService.DEMAND_ARCHIVING_RESOURCE_ID]
}), {})(withRouter(ArchivingPanel));